module.exports = __webpack_public_path__ + "static/media/opensans-light-webfont.c1596d95.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-light-webfont.woff2
// module id = 1017
// module chunks = 0